import * as React from "react"

export function Footer() {
  return (
    <footer className="footer"
    >
      <p>Copyright © {new Date().getFullYear()} |P|H|A|C|C|</p>
    </footer>
  )
}
